import request from '@/utils/request'
// import qs from 'querystring';

// export function login(data) {
//   return request({
//     url: '/connect/token',
//     method: 'post',
//     headers: { 'content-type': 'application/x-www-form-urlencoded' },
//     data: qs.stringify(data)
//   })
// }

// export function login(data) {
//   return request({
//     url: '/connect/token',
//     method: 'post',
//     headers: { 'content-type': 'application/x-www-form-urlencoded' },
//     data: qs.stringify(data)
//   })
// }

export function login(data) {
  console.log(data, 'logindata');
  return request({
    url: '/api/account/login',
    method: 'post',
    data: data
  })
}

export function getInfo() {
  return request({
    url: '/api/account/my-profile',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/api/account/logout',
    method: 'get'
  })
}

export function register(data) {
  return request({
    url: '/api/account/register',
    method: 'post',
    data: data
  })
}

export function setUserInfo(data) {
  return request({
    url: '/api/account/my-profile',
    method: 'put',
    data: data
  })
}

export function changePassword(data) {
  return request({
    url: '/api/account/my-profile/change-password',
    method: 'post',
    data: data
  })
}

export function passwordToken() {
  return request({
    url: '/api/identity/login/token',
    method: 'post'
  })
}

export function passlessLogin(data) {
  return request({
    url: `/api/identity/login/login?ticket=${data.ticket}&url=${data.url}`,
    method: 'get'
  })
}

export function passlessLoginzt() {
  return request({
    url: `/api/identity/login/loginZt`,
    method: 'get'
  })
}

export function vali(data) {
  return request({
    url: '/api/identity/login/test',
    method: 'get',
    params: data
  })
}

export function getUserInfo(username,name){
  return request({
    url: '/api/identity/users/queryuserdto',
    method: 'get',
    params: {
      username,
      name
    }
  })
}